export enum WorkflowType {
    EVALUATION = 'media_evaluation',
    PUBLISH = 'media_publish',
    UPLOAD = 'media_upload'
}
